if (!customElements.get("m-scrolling-promotion")) {
  class MScrollingPromotion extends HTMLElement {
    constructor() {
      super();
      this.clonesCreated = false;
      this.observer = null;
    }

    connectedCallback() {
      this.promotion = this.querySelector(".m-promotion");
      this.init();
      
      // Listen for window resize
      window.addEventListener('resize', this.handleResize.bind(this));
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize.bind(this));
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    init() {
      const isDesktop = window.innerWidth >= 1024;
      
      if (isDesktop) {
        // Desktop: disable marquee
        this.disableMarquee();
      } else {
        // Mobile/Tablet: enable marquee
        this.enableMarquee();
      }
    }

    enableMarquee() {
      if (this.childElementCount === 1 && !this.clonesCreated) {
        this.promotion.classList.add("m-promotion--animated");

        // Create 10 clones for seamless scrolling
        for (let index = 0; index < 10; index++) {
          this.clone = this.promotion.cloneNode(true);
          this.clone.setAttribute("aria-hidden", true);
          this.appendChild(this.clone);
        }
        
        this.clonesCreated = true;

        // Pause when out of view
        this.observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        this.observer.observe(this);
      } else if (this.clonesCreated) {
        // Re-enable animation if clones already exist
        this.promotion.classList.add("m-promotion--animated");
        this.scrollingPlay();
      }
    }

    disableMarquee() {
      if (this.clonesCreated) {
        // Remove animation class
        this.promotion.classList.remove("m-promotion--animated");
        
        // Remove all cloned elements
        const clones = Array.from(this.querySelectorAll('.m-promotion[aria-hidden="true"]'));
        clones.forEach(clone => clone.remove());
        
        // Disconnect observer
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
        
        this.clonesCreated = false;
      }
    }

    handleResize() {
      this.init();
    }

    scrollingPlay() {
      this.classList.remove("m-scrolling-promotion--paused");
    }

    scrollingPause() {
      this.classList.add("m-scrolling-promotion--paused");
    }
  }

  customElements.define("m-scrolling-promotion", MScrollingPromotion);
}